export default function Loader({ label = "Cargando…", fullscreen = true, testId = "loader" }) {
  const wrapper = fullscreen
    ? "min-h-screen bg-void grain flex items-center justify-center"
    : "flex items-center justify-center py-12";
  return (
    <div className={wrapper} data-testid={testId}>
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 rounded-full border-2 border-gold/25 border-t-gold animate-spin" />
        <div className="font-display text-lg tracking-widest text-neutral-300">{label}</div>
      </div>
    </div>
  );
}
